module.exports = __webpack_public_path__ + "img/icon_close.f1c65088.png";